// import Tooltip from "@ui/external/components/tooltip";
import { ColumnType } from "@utils/interface/index.interface";

type UserPredictions = {
  user_id: number;
  full_name: string;
  display_name: string;
  email: string;
  phone_number: string;
  total_score: number;
  stats: {
    matches_predicted: number;
    points_from_toss: number;
    points_from_winner: number;
    points_from_player: number;
  };
};

const ColumnList = ({ onView }: { onView: (row: UserPredictions) => void }) => {
  const column: ColumnType<UserPredictions>[] = [
    {
      name: "ID",
      cell: (row) => (
        <span className="font-semibold text-gray-700">
          {/* {row?.user_id || "N/A"} */}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Display Name",
      cell: (row) => (
        <span className="font-semibold text-gray-700">
          {row?.display_name || "N/A"}
        </span>
      ),
      sortable: true,
    },
    {
      name: "Details",
      cell: (row) => (
        <div className="text-gray-500 text-sm">
          <p>{row?.full_name}</p>
          <p>{row?.email}</p>
          <p>{row?.phone_number}</p>
        </div>
      ),
      sortable: false,
    },
    {
      name: "Matches Predicted",
      cell: (row) => (
        <p className="w-[50%] flex justify-center">
          {row?.stats?.matches_predicted || 0}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Toss Points",
      cell: (row) => (
        <p className="w-[50%] flex justify-center">
          {row?.stats?.points_from_toss || 0}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Match Points",
      cell: (row) => (
        <p className="w-[50%] flex justify-center">
          {row?.stats?.points_from_winner || 0}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Player of Match Points",
      cell: (row) => (
        <p className="text-green-600 font-medium">
          {row?.stats?.points_from_player || 0}
        </p>
      ),
      sortable: true,
    },
    {
      name: "Total Points",
      cell: (row) => <p className="font-semibold">{row?.total_score || 0}</p>,
      sortable: true,
    },
    {
      name: "Actions",
      cell: (row) => (
        <div
          className="text-[#1DA077] cursor-pointer hover:underline"
          onClick={() => onView(row)}
        >
          View
        </div>
      ),
      sortable: false,
    },
  ];
  return column;
};

export { ColumnList };
